// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-search-js": () => import("./../../../src/pages/search.js" /* webpackChunkName: "component---src-pages-search-js" */),
  "component---src-templates-newsfeed-js": () => import("./../../../src/templates/newsfeed.js" /* webpackChunkName: "component---src-templates-newsfeed-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-page-lang-splash-js": () => import("./../../../src/templates/page-lang-splash.js" /* webpackChunkName: "component---src-templates-page-lang-splash-js" */)
}

